import { deserializeHTMLToElement } from './deserializeHTMLToElement.mjs';
import { deserializeHTMLToFragment } from './deserializeHTMLToFragment.mjs';
import { deserializeHTMLToMarks } from './deserializeHTMLToMarks.mjs';
import { deserializeHTMLToText } from './deserializeHTMLToText.mjs';

/**
 * Deserialize HTML element or child node.
 */
const deserializeHTMLNode = plugins => node => {
  // Text node
  const textNode = deserializeHTMLToText({
    node,
    plugins
  });
  if (textNode) {
    return textNode;
  }

  // No-op if not an element node
  if (node.nodeType !== Node.ELEMENT_NODE) {
    return null;
  }

  // Recursively deserialize children
  const deserialize = deserializeHTMLNode(plugins);
  const children = Array.from(node.childNodes).reduce((acc, node) => {
    const deserialized = deserialize(node);
    return acc.concat(Array.isArray(deserialized) ? deserialized : [deserialized]);
  }, []);

  // Body
  const htmlElement = node;
  const fragment = deserializeHTMLToFragment({
    element: htmlElement,
    children
  });
  if (fragment) {
    return fragment;
  }

  // Element
  const element = deserializeHTMLToElement({
    plugins,
    element: htmlElement,
    children
  });
  if (element) {
    return element;
  }

  // Marks
  return deserializeHTMLToMarks({
    plugins,
    element: htmlElement,
    children
  });
};

export { deserializeHTMLNode };
